const { formatOrderItem } = require('./helpers');

const isMatch = ({ refMatchKey, itemMatchKey, strictEqual }) => (a,b) => {
  if(strictEqual) return a[refMatchKey] === b[itemMatchKey];
  return a[refMatchKey].equals(b[itemMatchKey]);
};

module.exports = function(items, { type = 'items', references = [], keysToCopy = [], refMatchKey = 'producerproduct_id', itemMatchKey = 'producerproduct_id', strictEqual = false }){

  const match = isMatch({ refMatchKey, itemMatchKey, strictEqual });

  if(!items){
    return [];
  }

  return items.map(item => {

    const output = {};
    const ref = references.find(
      r => match(r, item)
    );
    if(!ref){
      console.warn(`ref not found, item ${JSON.stringify(item)}`);
    }

    if(type){
      output.type = type;
    }

    for(let key of keysToCopy){
      if(typeof item[key] !== 'undefined'){
        output[key] = item[key];
      }
      else if(ref){
        if(typeof ref[key] !== 'undefined'){
          output[key] = ref[key];
        }
      }
    }

    return formatOrderItem(output, keysToCopy);
  });
};